import PropTypes from 'prop-types';

const propType = {
  url: PropTypes.string.isRequired,
  thumb: PropTypes.string,
  duration: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  name: PropTypes.string,
};

export default { propType };
